import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cs from 'classnames';
import { DEFAULT_CURRENCY } from '../../config';
import formatCurrency from '../../helpers/formatCurrency';
import CirclesLoadingAnimation from '../Loaders/CirclesLoadingAnimation';

import styles from './index.module.scss';

const Currency = (props) => {
  const {
    value,
    currency,
    placeholder,
    withCurrencyLabel,
    withSymbol,
    fractionDigits,
    styling,
    isNegativeValue,
    isFetching,
  } = props;

  const { t } = useTranslation();

  const amd = 'AMD';
  const usd = 'USD';
  const eur = 'EUR';

  const isInvalidValue = value === null || Number.isNaN(Number(value));

  if (isInvalidValue) {
    return (
      <span>
        <span className={styling && styling.amount}>{placeholder}</span>
      </span>
    );
  }

  const formattedCurrency = formatCurrency(value, fractionDigits, fractionDigits);

  const getLabelAndSymbol = () => {
    switch (currency.toUpperCase()) {
      case amd:
        return {
          label: t('currency.AMD'),
          symbol: '֏',
        };
      case eur:
        return {
          label: t('currency.EUR'),
          symbol: '€',
        };
      case usd:
        return {
          label: t('currency.USD'),
          symbol: '$',
        };
      default:
        return {
          label: currency,
          symbol: '',
        };
    }
  };

  const { label, symbol } = getLabelAndSymbol();

  if (isFetching) {
    return (
      <div>
        <CirclesLoadingAnimation />
      </div>
    );
  }

  return (
    <span>
      {withSymbol && (
        <span className={cs(styles.symbol, styling && styling.symbol)}>{symbol}</span>
      )}
      <span className={cs(styles.amount, styling && styling.amount)}>
        {!!value && isNegativeValue && '-'}
        {formattedCurrency}
      </span>
      {withCurrencyLabel && (
        <span className={styling && styling.label}>
          {` ${label}`}
        </span>
      )}
    </span>
  );
};

Currency.propTypes = {
  currency: PropTypes.string,
  value: PropTypes.number,
  placeholder: PropTypes.string,
  withCurrencyLabel: PropTypes.bool,
  withSymbol: PropTypes.bool,
  fractionDigits: PropTypes.number,
  styling: PropTypes.instanceOf(Object),
  isNegativeValue: PropTypes.bool,
  isFetching: PropTypes.bool,
};

Currency.defaultProps = {
  currency: DEFAULT_CURRENCY,
  value: null,
  placeholder: '-',
  withCurrencyLabel: false,
  withSymbol: false,
  fractionDigits: null,
  styling: null,
  isNegativeValue: false,
  isFetching: false,
};

export default Currency;
